import api from '../api';

const REQUESTS_LIST = api.events.requestsList.actionSuccess;

const defaultState = { list: [] };

export default (state = defaultState, action) => {
  switch (action.type) {
    case REQUESTS_LIST:
      return { ...state };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/requests.js